import { ReactNode } from "react"
import AppLayout from "@/layouts/AppLayout"
import { usePage } from "@inertiajs/react"
import { PuzzlesIndexProps } from "@/types/types"
import DashboardTopbar from "@/components/DashboardTopbar"
import FrozenBoard from "@/components/puzzle/FrozenBoard"
import Button from "@/components/Button"
import Pagination from "@/components/Pagination"
import useUser from "@/hooks/useUser"

const PuzzlesIndexPage = () => {
  const { puzzles } = usePage<PuzzlesIndexProps>().props
  const { isAuthenticated } = useUser()

  return (
    <>
      <DashboardTopbar title="Puzzles">
        {isAuthenticated && (
          <Button size="sm" style="secondary" href="/puzzles/me">
            My puzzles
          </Button>
        )}
      </DashboardTopbar>

      <div className="padding mx-auto grid w-full max-w-96 gap-x-6 gap-y-6 py-8 sm:gap-y-8 md:max-w-[1450px] md:grid-cols-2 lg:grid-cols-3">
        {puzzles.map((puzzle) => (
          <div
            key={puzzle.id}
            className="group focus-within:outline-chessdrop-200 relative flex flex-col rounded-xl border border-gray-200 bg-white p-6 focus-within:outline-4 focus-within:outline-offset-0"
          >
            <div className="flex-1">
              <h2 className="line-clamp-1 text-base font-semibold text-gray-900">
                <a
                  href={`/puzzles/${puzzle.id}`}
                  className="focus:outline-none"
                >
                  {/* Extend touch target to entire panel */}
                  <span aria-hidden="true" className="absolute inset-0 z-10" />
                  {puzzle.title}
                </a>
              </h2>
              <p className="mt-2 line-clamp-2 text-sm text-gray-500">
                {puzzle.description}
              </p>
            </div>

            <div className="mt-4 aspect-square w-full bg-gray-100">
              <FrozenBoard fen={puzzle.start} />
            </div>
          </div>
        ))}
      </div>

      <Pagination type="puzzle" />
    </>
  )
}

export default PuzzlesIndexPage

PuzzlesIndexPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
